// Auto-derive the backend URL from whatever hostname the frontend is running on.
//
// Convention: frontend lives on  ludo.<domain>
//             backend  lives on  ludoapi.<domain>
//
// Local laptop:  localhost:3040 -> localhost:3041
// Local phone:   192.168.x.x:3040 -> same LAN host on port 3041
// Production:    ludo.example.com -> ludoapi.example.com

const isLoopbackHost = hostname => (
    hostname === 'localhost'
    || hostname === '127.0.0.1'
    || hostname === '::1'
    || hostname === '[::1]'
);

const isPrivateLanHost = hostname => {
    if (/^192\.168\./.test(hostname) || /^10\./.test(hostname)) return true;
    const match = hostname.match(/^172\.(\d+)\./);
    if (match) {
        const secondOctet = Number(match[1]);
        if (secondOctet >= 16 && secondOctet <= 31) return true;
    }
    return hostname.endsWith('.local');
};

const isLocalOverride = value => {
    try {
        const hostname = new URL(value).hostname;
        return isLoopbackHost(hostname) || isPrivateLanHost(hostname);
    } catch (_) {
        return false;
    }
};

export const deriveBackendUrl = (
    locationLike = window.location,
    overrideValue = process.env.REACT_APP_BACKEND_URL
) => {
    const hostname = String(locationLike?.hostname || '').trim();
    const protocol = String(locationLike?.protocol || 'http:');
    const override = String(overrideValue || '').trim().replace(/\/$/, '');
    const loopbackPage = isLoopbackHost(hostname);
    const lanPage = isPrivateLanHost(hostname);

    // A public/staging override is always deliberate. A localhost override is
    // valid only on the same laptop; LAN phones must use the laptop's LAN host.
    if (override && (!isLocalOverride(override) || loopbackPage)) return override;

    if (loopbackPage) return `http://${hostname === '[::1]' ? '[::1]' : hostname}:3041`;
    if (lanPage) return `${protocol}//${hostname}:3041`;

    const labels = hostname.split('.').filter(Boolean);
    const apiHost = labels.length <= 2
        ? `ludoapi.${hostname}`
        : hostname.replace(/^[^.]+/, 'ludoapi');
    return `${protocol}//${apiHost}`;
};

export const backendUrl = deriveBackendUrl();

// Derive WebSocket URL — swap http(s): → ws(s):
export const getWebSocketUrl = () => backendUrl.replace(/^http/, 'ws');
